import styled from 'styled-components';
import { CardS } from '../../GlobalStyles';
import { RGBA_COLORS } from '../../utils/colors';
import { VIDEO_SMALL_HEIGHT, VIDEO_SMALL_WIDTH } from '../../utils/consts';

export const WrapperS = styled(CardS)<{ isFullScreen?: boolean; isHideVideo?: boolean }>`
  flex: 1;
  position: absolute;
  z-index: 100;
  ${({ isFullScreen }) => (isFullScreen ? `width: 100%;` : `width: ${VIDEO_SMALL_WIDTH};`)}
  ${({ isFullScreen }) => (isFullScreen ? `height: 100%;` : `height: ${VIDEO_SMALL_HEIGHT};`)}
    ${({ isFullScreen }) => (isFullScreen ? `top: 0;` : `left: 10px; bottom: 10px;`)}
    ${({ isFullScreen }) =>
    !isFullScreen
      ? `
      
  .titleBlock {
    span {
      display: none;
    }
  }
  `
      : `left: 0;`}
  ${({ isFullScreen, isHideVideo }) =>
    isHideVideo && !isFullScreen
      ? `
      height: 60px;
      & > * {
          &:nth-child(2) {
              display: none;
          }
      }
      @media screen and (max-width: 1400px) {
        padding: 0;
        width: 240px;
        height: 42px;
      }
      @media screen and (max-width: 1150px) {
        width: 180px;
      }
      `
      : ``}
`;

export const IframeS = styled.iframe<{ isFullScreen?: boolean }>`
  height: 100%;
  width: 100%;
  border: 0;
`;
export const HeaderS = styled.div<{ isFullScreen?: boolean }>`
  display: flex;
  position: relative;
  align-items: center;
  ${({ isFullScreen }) =>
    isFullScreen
      ? `
      button {
        right: 10px;
        position: absolute;
        color: white;
        padding: 0;
        margin: -5px 0 0;
        top: 50%;
        transform: translateY(-50%);
        font-size: 20px;
      }
    `
      : `
      & > * {
        &:nth-child(2) {
          font-size: xx-large;
          right: 45px;
          position: absolute;
          color: white;
          padding: 0;
          margin: -5px 0 0;
          top: 50%;
          transform: translateY(-80%);
        }
        &:nth-child(3) {
          right: 10px;
          position: absolute;
          color: white;
          padding: 0;
          margin: -5px 0 0;
          top: 50%;
          transform: translateY(-50%);
          font-size: 20px;
        }
      }
    `}
`;

export const WrapperMessage = styled.div<{ isFullScreen?: boolean }>`
  border: 1px solid ${RGBA_COLORS.getAccent()};
  ${({ isFullScreen }) =>
    isFullScreen
      ? `
      margin-top: 10px;
      padding: 10px;
    `
      : `
      margin-top: 6px;
      padding: 5px;
    `}
  & > * {
    &:nth-child(1) > * {
      &:nth-child(2) {
        margin: 0;
        width: 100%;
        ${({ isFullScreen }) =>
          !isFullScreen
            ? `
              max-width: 226px;
              max-height: 60px;
              overflow: auto;`
            : `
              max-height: 200px;
              overflow: auto;`}
      }
    }
  }
`;
